import React from 'react';
import { ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';

export default function SubmitBar({ onBack, onNext, nextLabel = 'Next', backLabel = 'Back', disabled, hideBack = false, disableBack = false, loading = false, loadingLabel = 'Checking postcode...', variant = 'default' }) {
  const harbour = variant === 'harbour';
  const containerClass = hideBack
    ? 'flex items-center justify-end my-4'
    : 'flex flex-row-reverse items-center justify-between my-4';
  return (
    <div className={containerClass}>
      <button
        type="button"
        onClick={onNext}
        disabled={disabled}
        // Ensure icon and text render on the same line and do not wrap
        className={`inline-flex items-center whitespace-nowrap font-semibold py-2 px-4 rounded-lg transition-all ${disabled ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white bg-primary hover:bg-primary/90'}`}
      >
        {loading ? (
          <span className="inline-flex items-center gap-2">
            <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            <span>{loadingLabel}</span>
          </span>
        ) : (
          <span className="inline-flex items-center">
            {nextLabel}
            {harbour
              ? <ArrowRightIcon className="w-5 h-5 ml-2" aria-hidden="true" />
              : <ChevronRightIcon className="font-bold w-4 h-4 ml-1" aria-hidden="true" />}
          </span>
        )}
      </button>
      {!hideBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={disableBack}
          // Match forward button sizing, but with transparent bg and subtle hover
          className={`inline-flex items-center whitespace-nowrap font-semibold py-2 px-4 rounded-lg transition-all ${disableBack ? 'text-gray-400 cursor-not-allowed' : 'text-primary hover:bg-primary/5'}`}
        >
          {harbour ? null : <ChevronLeftIcon className="font-bold w-4 h-4 mr-1" aria-hidden="true" />}
          {backLabel}
        </button>
      )}
    </div>
  );
}


